import { gql } from 'apollo-boost';

export const myEmailTemplates = gql`
  {
    myEmailTemplates {
        edges {
            node {
                dbId
                name
                body
                accountId
            }
        }
    }
  }
`;
